function arraysEqual<T>(arr1: T[], arr2: T[]): boolean {
  if (arr1.length !== arr2.length) return false;

  const copyArr2 = [...arr2];
  for (const item1 of arr1) {
    const index = copyArr2.findIndex((item2) => deepEqual(item1, item2));
    if (index === -1) {
      return false;
    }
    copyArr2.splice(index, 1);
  }

  return true;
}

export function deepEqual<T>(obj1: T, obj2: T): boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const stack: Array<[any, any]> = [[obj1, obj2]];

  while (stack.length > 0) {
    const [currentObj1, currentObj2] = stack.pop()!;

    if (typeof currentObj1 !== typeof currentObj2) return false;
    if (
      typeof currentObj1 !== "object" ||
      currentObj1 === null ||
      currentObj2 === null
    ) {
      if (currentObj1 !== currentObj2) return false;
      continue;
    }

    if (Array.isArray(currentObj1) && Array.isArray(currentObj2)) {
      if (!arraysEqual(currentObj1, currentObj2)) return false;
      continue;
    }

    const keys1 = Object.keys(currentObj1);
    const keys2 = Object.keys(currentObj2);

    if (keys1.length !== keys2.length) return false;

    for (const key of keys1) {
      if (!(key in currentObj2)) return false;
      stack.push([currentObj1[key], currentObj2[key]]);
    }
  }

  return true;
}
